import { call, put, select, takeLatest } from 'redux-saga/effects'
import { HomeConstants } from '../../home/store/home.constants'
import { setCrewList } from '../store/exposure.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { getExposureOptionsSelector } from '../../options/selectors'
import { IExposureOptionsState } from '../../options/store/options.types'
import { getCrewListSelector } from '../../crew/selectors'
import { ICrewMemberList } from '../../crew/store/crew.types'
import { IPcr } from '../../pcr/store/pcr.types'
import { getPcrIdSelector } from '../../home/selectors'
import { getServiceIdSelector } from '../../user/selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'

export function* setExposureCrewList(pcrDoc: IPcr) {
  const exposureOptions: IExposureOptionsState = yield select(getExposureOptionsSelector)
  const crewList: ICrewMemberList = yield select(getCrewListSelector)

  const { exposure } = pcrDoc
  const { exposureCrewOptions } = exposureOptions
  const exposureCrewList = crewList.map(({ userId }) => userId).concat(exposureCrewOptions)
  if (exposure === undefined) {
    yield put(setCrewList(exposureCrewList))
  }
}

export function* preloadPCR() {
  const pcrID: string = yield select(getPcrIdSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  if (!pcrID) return

  try {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    yield call(setExposureCrewList, pcrDoc)
  } catch (e) {
    yield put(throwPcrException(`preloadPCR() error in setExposureCrewList.saga.ts: ${e}`))
  }
}

export function* setExposureCrewListSaga() {
  yield takeLatest([HomeConstants.SET_NEW_PCR], performWithMutexHOG, preloadPCR)
}
